export var TEXT_BUTTON_TYPES = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
});